/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Custom_Price_HintInputs */

const en_lesson_custom_price_hint = /** @type {(inputs: Lesson_Custom_Price_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(leave empty to use rate × duration)`)
};

const he_lesson_custom_price_hint = /** @type {(inputs: Lesson_Custom_Price_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(השאר ריק כדי להשתמש בתעריף × משך)`)
};

/**
* | output |
* | --- |
* | "(leave empty to use rate × duration)" |
*
* @param {Lesson_Custom_Price_HintInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_custom_price_hint = /** @type {((inputs?: Lesson_Custom_Price_HintInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Custom_Price_HintInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_custom_price_hint(inputs)
	return he_lesson_custom_price_hint(inputs)
});